import React from 'react';

export default function PaginationBar({ currentPage, totalPages, onPrev, onNext }) {
  if (totalPages <= 1) return null;
  return (
    <div style={{ margin: '1rem 0', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 16 }}>
      <button onClick={onPrev} disabled={currentPage === 1}>Previous</button>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <button onClick={onNext} disabled={currentPage === totalPages}>Next</button>
    </div>
  );
}
